import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import { useSelector, useDispatch } from "react-redux";
import { selectFormattedDemoCountries, selectFormattedLogisticCountries, fetchHomePageLogisticCountries } from "@/store/modern/slices/countrySlice";
import { supplierAndLogPartnterSuggetion } from "@/store/modern/slices/memberSlice";
import { map } from 'lodash';
import { publicRoutePaths } from "@/routes/public.routes.config";
import defaultValues from "@/constant/defaultValues";
import { useAuth } from "@/AuthProvider";
import roles from "@/constant/roles.config";
import { privateRoutePaths } from "@/routes/private.route.config";
import { buildPath } from "@/utils/common";
import RadioButtonField from "@/components/RadioButtonField";

const FindPartner = () => {
  const { user, isPreKYCUser, isDemoUser, isEndUser, isViewer } = useAuth();
  const searchRef = useRef(null);
  const { SHIPMENT_OPTION, SEARCH_BY_OPTION } = defaultValues;
  const countries = useSelector(selectFormattedDemoCountries);
  const logisticsCountries = useSelector(selectFormattedLogisticCountries);
  const [query, setQuery] = useState(null);
  const [results, setResults] = useState({ companies: [], industries: [], hsCode: [] });
  const [loading, setLoading] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [searchTxt, setSearchText] = useState(null);
  const dispatch = useDispatch();
  const nav = useNavigate();


  const [selectedShipment, setSelectedShipment] = useState(SHIPMENT_OPTION[1]);
  const [selectedSearchOption, setSelectedSearchOption] = useState(SEARCH_BY_OPTION[0]);
  const [shouldSubmit, setShouldSubmit] = useState(false);

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  const fetchSuggestions = async (text) => {
    setLoading(true);

    let searchTerm = text;
    if (selectedProduct && selectedProduct.description) {
      searchTerm = selectedProduct.description;
    }
    try {
      const response = await dispatch(supplierAndLogPartnterSuggetion(searchTerm));
      if (response && response.meta?.requestStatus === "fulfilled") {
        if (response.payload?.status === "success") {
          setResults(response.payload);
          return;
        }
      }

    } catch (error) {
      console.error("Error fetching suggestions:", error);
      setResults({ companies: [], industries: [], hsCode: [] });
    } finally {
      setLoading(false);
    }
  };

  const handleSelectSuggestion = (value, type) => {
    setShowSuggestions(false);

    if (type === "hsCodeDescription") {
      if (!value || !value.code || !value.description) return;

      const fullText = `${value.code} - ${value.description}`;
      setQuery(fullText);
      setSelectedProduct({
        code: value.code,
        description: value.description,
        codeAndDesc: fullText,
      });

      setSelectedCompany(null);
      setSelectedIndustry(null);
    } else if (type === "company") {
      const cleanValue = value.trim();
      setQuery(cleanValue);
      setSelectedCompany(cleanValue);
      setSelectedIndustry(null);
      setSelectedProduct(null);
    } else if (type === "industry") {
      const cleanValue = value.trim();
      setQuery(cleanValue);
      setSelectedIndustry(cleanValue);
      setSelectedCompany(null);
      setSelectedProduct(null);
    }
    setSearchText(null);
    setResults({ companies: [], industries: [], hsCode: [] });

    setShouldSubmit(true);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    setSelectedProduct(null);
    setSelectedCompany(null);
    setSelectedIndustry(null);

    if (value.length >= 2) {
      fetchSuggestions(value);
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
      setResults({ companies: [], industries: [], hsCode: [] });
    }

  };

  const handleInputSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);

  };

  const handleInputFocus = () => {
    if (typeof query === 'string' && query.length > 1) {
      setShowSuggestions(true);
      fetchSuggestions(query);
    }
  };

  const handleCountryChange = (cval) => {
    setSelectedCountry(cval);
    setSearchText(null);
    if (selectedShipment?.value == 'logistic' && cval != null) {
      setShouldSubmit(true);
    }
  };

  const handleSearchChange = (val) => {
    if (!val) {
      return;
    }
    setSelectedSearchOption(val);
    setSelectedCountry(null);
    setSearchText(null);
  }

  const handleTypeChange = (e, type) => {
    setSelectedShipment((prev) =>
      prev.value === "supplier" ? SHIPMENT_OPTION[1] : SHIPMENT_OPTION[0]
    );
    setQuery(null);
    setSelectedIndustry(null);
    setSelectedCompany(null);
    setSelectedProduct(null);
    setSelectedCountry(null);
    setSelectedSearchOption(SEARCH_BY_OPTION[0]);
    setSearchText(null);
  };

  const handleSubmit = async () => {
    const type = selectedShipment?.value ?? null;
    if (user && type) {
      if (user?.role_slug?.slug === "SUP_ADM" || user?.role_slug?.slug === "VIEWER" || user?.role_slug?.slug === "END_USER") {
        if (type === 'supplier') {
          nav(`/${getPrefix()}${privateRoutePaths.MANAGE_MEMBERS.path}`);
        }
        if (type === 'logistic') {
          nav(`/${getPrefix()}${privateRoutePaths.MANAGE_LOGISTIC_MEMBERS.path}`);
        }
      }
      if (user?.role_slug?.slug === "DEMO") {
        if (type === 'supplier') {
          nav(`/${getPrefix()}${privateRoutePaths.SHIPMENT_COMPANY_LIST.path}`);
        }
        if (type === 'logistic') {
          nav(`/${getPrefix()}${privateRoutePaths.MANAGE_LOGISTIC_MEMBERS.path}`);
        }
      }

      if (user?.role_slug?.slug === "PRE_KYC") {
        nav(`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`);
      }

    }
    else {

      let url = publicRoutePaths.SEARCH_DETAIL.path;

      //  let country = selectedCountry?.countryId ?? null;
      const country = selectedCountry?.countryCode ?? null;
      const company = selectedCompany ?? null;
      const industry = selectedIndustry ?? null;
      const product = selectedProduct?.code ?? null;
      const search = searchTxt ?? null;
      const searchBy = selectedSearchOption?.value ?? null;
      const query0 = query ?? null;

      const params = new URLSearchParams();
      if (type !== null) params.append('type', type);
      if (country !== null) params.append('country', country);
      if (type === 'supplier') {
        if (company !== null) params.append('company', company);
        if (industry !== null) params.append('industry', industry);
        if (product !== null) params.append('product', product);
        if (query0 !== null && (company === null || industry === null || product === null)) params.append('query', query0);
      }
      if (type === 'logistic') {
        if (searchBy !== null) params.append('searchBy', searchBy);
        if (search !== null) params.append('search', search);
      }
      if ([...params].length > 0) {
        url += '?' + params.toString();
      }

      window.open(url, "_blank", "noopener,noreferrer");

    }
  };

  const handleClearClick = () => {
    setSearchText("");
  }

  const handleSupplierClearClick = () => {
    setQuery("");
    setSelectedCompany("");
    setSelectedIndustry("");
    setSelectedProduct("");
  }

  useEffect(() => {
    if (typeof query === 'string' && query.length > 1 && showSuggestions) {
      const delayDebounce = setTimeout(() => {
        fetchSuggestions(query);
      }, 300);

      return () => clearTimeout(delayDebounce);
    } else {
      setResults({ companies: [], industries: [], hsCode: [] });
    }
  }, [query, showSuggestions]);


  useEffect(() => {
    if (shouldSubmit) {
      handleSubmit();
      setShouldSubmit(false);
    }
  }, [shouldSubmit, query, selectedProduct, selectedCompany, selectedIndustry]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

    useEffect(() => {
        dispatch(fetchHomePageLogisticCountries());
    }, [dispatch]);


  return (
    <>
      <section className="find-parter-wrape">
        <div className="inner">
          <div className="head">
            <h3>FIND <span>{selectedShipment?.value === 'supplier' ? 'SUPPLIERS' : 'LOGISTICS PARTNER'}</span></h3>
            <div className="right-section">
              <div className="trigger-wrapes">
                <span>
                  <div className="d-flex">
                    <div className="r-buttn">
                      <label className="">
                        <RadioButtonField
                          onChange={(e) =>
                            handleTypeChange(e)
                          }
                          checked={selectedShipment.value === "logistic"}
                        />
                        Logistics</label>
                    </div>
                    <div className="r-buttn">
                      <label className="">
                        <RadioButtonField
                          onChange={(e) =>
                            handleTypeChange(e)
                          }
                          checked={selectedShipment.value === "supplier"}
                        />
                        Suppliers</label>
                    </div>
                  </div>
                </span>

              </div>


            </div>
          </div>
          <div className="body">
            <div className="form-section">
              <div className="container">
                <div className="row">
                  {selectedShipment?.label === "Suppliers" ? (
                    <>
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12">
                        <div className="input-wrape">
                          <div className="input-pad select-wrape">
                            <Select
                              name="country_id"
                              options={countries}
                              value={selectedCountry}
                              onChange={handleCountryChange}
                              placeholder="Select country"
                              classNamePrefix={"Drop-down-menu"}
                              noOptionsMessage={() => "No Country Found"}
                              isClearable={true}
                            // components={{ DropdownIndicator }}
                            // menuPlacement="top"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-12" ref={searchRef}>
                        <div className="input-wrape">
                          <div className="input-pad">
                            <input
                              type="text"
                              placeholder="By product, industry or company"
                              value={query}
                              onChange={handleInputChange}
                              onFocus={handleInputFocus}
                              autoComplete="off"
                              className="input"
                            />
                            <span
                              onClick={handleSupplierClearClick}
                              style={{
                                position: 'absolute',
                                top: '50%',
                                right: '10px',
                                transform: 'translateY(-50%)',
                                display: query ? 'flex' : 'none',
                                cursor: 'pointer'
                              }}
                            >
                              <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" class="css-Svg"><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg>
                            </span>
                          </div>
                              
                          {loading && (
                            <div className="load-dotes">...</div>
                          )}

                          {showSuggestions && (results.companies.length > 0 || results.industries.length > 0 || results.hsCode.length > 0) && (
                            <div className="dd-wrape">

                              {results.hsCode.length > 0 && (
                                <>

                                  {selectedProduct?.code ? (
                                    <ul >
                                      {results.hsCode
                                        .filter((hsCode) => hsCode.code === selectedProduct.code)
                                        .map((hsCode, idx) => (
                                          <li
                                            key={idx}
                                            onClick={() => handleSelectSuggestion(hsCode, "hsCodeDescription")}

                                          >
                                            <span >{hsCode.code}</span> - {hsCode.description}
                                          </li>
                                        ))}
                                    </ul>
                                  ) : (
                                    <>
                                      <h5 className="sub-head" >Product</h5>
                                      <ul >
                                        {results.hsCode.map((hsCode, idx) => (
                                          <li
                                            key={idx}
                                            onClick={() => handleSelectSuggestion(hsCode, "hsCodeDescription")}

                                          >
                                            <span >{hsCode.code}</span> - {hsCode.description}
                                          </li>
                                        ))}
                                      </ul>
                                    </>
                                  )}
                                </>
                              )}

                              {results.industries.length > 0 && (
                                <>
                                  <h5 className="sub-head">Industries</h5>
                                  <ul >
                                    {map(results?.industries, (industry, idx) => (
                                      <li
                                        key={idx}
                                        onClick={() => handleSelectSuggestion(industry, "industry")}

                                      >
                                        {industry}
                                      </li>
                                    ))}
                                  </ul>
                                </>
                              )}

                              {results.companies.length > 0 && (
                                <>
                                  <h5 className="sub-head">Companies</h5>
                                  <ul>
                                    {map(results?.companies, (company, idx) => (
                                      <li
                                        key={idx}
                                        onClick={() => handleSelectSuggestion(company, "company")}
                                      >
                                        {company}
                                      </li>
                                    ))}
                                  </ul>
                                </>
                              )}


                            </div>
                          )}

                          {/* No data found message */}
                          {showSuggestions &&
                            !loading &&
                            results.companies.length === 0 &&
                            results.industries.length === 0 &&
                            results.hsCode.length === 0 &&
                            query.length > 1 && (
                              <div className="no-result">
                                No Results
                              </div>
                            )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12">
                        <div className="input-wrape">
                          <div className="input-pad select-wrape">
                            <Select
                              name="search"
                              options={SEARCH_BY_OPTION}
                              value={selectedSearchOption}
                              onChange={handleSearchChange}
                              placeholder="Search by"
                              classNamePrefix={"Drop-down-menu"}
                              noOptionsMessage={() => "No Search Found"}
                            // menuPlacement="top"
                            />
                          </div>
                        </div>
                      </div>


                      {selectedSearchOption?.value === 'location' && (
                        <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-12">
                          <div className="input-wrape">
                            <div className="input-pad select-wrape">
                              <Select
                                name="country_id"
                                options={logisticsCountries}
                                value={selectedCountry}
                                onChange={handleCountryChange}
                                placeholder="Select country"
                                classNamePrefix={"Drop-down-menu"}
                                noOptionsMessage={() => "No Country Found"}
                                isClearable={true}
                              // menuPlacement="top"
                              />
                            </div>
                          </div>
                        </div>

                      )}
                      {selectedSearchOption?.value === 'company_name' && (
                        <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-12">
                          <div className="input-wrape">
                            <div className="input-pad">
                              <input type="text"
                                placeholder={`Enter company name`}
                                value={searchTxt}
                                onChange={handleInputSearchChange}
                                autoComplete="off"
                                className="input" />
                              <span
                                onClick={handleClearClick}
                                style={{
                                  position: 'absolute',
                                  top: '50%',
                                  right: '10px',
                                  transform: 'translateY(-50%)',
                                  display: searchTxt ? 'flex' : 'none',
                                  cursor: 'pointer'
                                }}
                              >
                                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" class="css-Svg"><path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path></svg>
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}

                </div>
              </div>

              <button type="button" className="btn icon-btn-primary" onClick={handleSubmit}
              // disabled={loading}
              >
                <i className="stripe search"></i> Search
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FindPartner;
